import { CustomerBlockStatus } from '../../types/customers';

type ScheduleBlockStatus = Pick<
  CustomerBlockStatus,
  'shopBlocked' | 'blockedEmployeeIds' | 'blockedArtists'
>;

export function isBlockedForSchedule(
  status: ScheduleBlockStatus,
  employeeId?: string | null,
) {
  if (status.shopBlocked) return true;
  if (employeeId && status.blockedEmployeeIds?.includes(employeeId)) {
    return true;
  }
  return false;
}

function getBlockedArtistName(
  status: ScheduleBlockStatus,
  employeeId: string,
): string {
  return (
    status.blockedArtists?.find(artist => artist.employeeId === employeeId)
      ?.name ?? 'this artist'
  );
}

export function getCustomerScheduleBlockWarning(
  status: ScheduleBlockStatus,
  employeeId?: string | null,
): { title: string; message: string } | null {
  if (!isBlockedForSchedule(status, employeeId)) return null;

  const shopBlocked = !!status.shopBlocked;
  const artistBlocked =
    !!employeeId && status.blockedEmployeeIds?.includes(employeeId);

  if (shopBlocked && artistBlocked) {
    const artistName = getBlockedArtistName(status, employeeId);
    return {
      title: 'Customer is blocked',
      message: `This customer is blocked shop-wide and by ${artistName}. They normally cannot book online.`,
    };
  }

  if (shopBlocked) {
    return {
      title: 'Customer is blocked',
      message:
        'This customer is blocked shop-wide. They normally cannot book with this shop online.',
    };
  }

  if (artistBlocked && employeeId) {
    const artistName = getBlockedArtistName(status, employeeId);
    return {
      title: 'Customer is blocked',
      message: `This customer is blocked by ${artistName}. They normally cannot book with this artist online.`,
    };
  }

  return {
    title: 'Customer is blocked',
    message: 'This customer is blocked. They normally cannot book online.',
  };
}
